import { getFromLS, isAdmin } from '@orientaction/utils';

const toId = (value: any): number | null => {
  const id = Number(typeof value === 'object' ? value?.id : value);
  return Number.isFinite(id) && id > 0 ? id : null;
};

export const getConnectedUser = () => JSON.parse(getFromLS('userInfos') || '{}');

export const isStaffViewer = (user = getConnectedUser()) => isAdmin(user);

export const getBeneficiaryTestsBackPath = (beneficiaryId?: number | string | null) => {
  const id = Number(beneficiaryId);
  if (!Number.isFinite(id) || id <= 0) {
    return '/admin/users-resultats';
  }
  return `/admin/users-resultats/beneficiaire/${id}?tab=resultats-tests`;
};

export const getBeneficiaryResourcesBackPath = (beneficiaryId?: number | string | null) => {
  const id = Number(beneficiaryId);
  if (!Number.isFinite(id) || id <= 0) {
    return '/admin/users-resultats';
  }
  return `/admin/users-resultats/beneficiaire/${id}?tab=resultats-ressources`;
};

export const getStaffResultBackPath = (
  location: { search?: string },
  beneficiaryId?: number | string | null
) => {
  const toBack = new URLSearchParams(location.search || '').get('toBack');
  if (toBack && toBack.startsWith('/')) {
    return toBack;
  }
  return getBeneficiaryTestsBackPath(beneficiaryId);
};

export const readBeneficiaryId = (
  location: { search?: string; state?: any },
  fallback?: any
) => {
  const fromQuery = new URLSearchParams(location.search || '').get('beneficiaryId');
  const fromState = location.state?.beneficiaryId;
  return fromQuery || fromState || toId(fallback) || null;
};

export const withBeneficiaryQuery = (path: string, beneficiaryId?: number | string | null) => {
  if (!beneficiaryId) {
    return path;
  }
  const [pathname, existingSearch = ''] = path.split('?');
  const params = new URLSearchParams(existingSearch);
  params.set('beneficiaryId', String(beneficiaryId));
  const search = params.toString();
  return search ? `${pathname}?${search}` : pathname;
};
